import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { snackbarTypes, snackbarActions } = createActionsStructure('snackbar', [
  { name: 'SHOW_SNACKBAR', async: false },
  { name: 'HIDE_SNACKBAR', async: false }
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/SnackbarActions.js